import { forkJoin, of } from 'rxjs';
import { concatMap, map } from 'rxjs/operators';
import { initialPageableQuery, UUID } from '../app/basicModels';
import { getCompany, getPhenomenonsTreeByCompany, getPhenomenonsTreeByWorkspace } from '../company/service';
import { Phenomenon } from '../phenomenon/models';

export const getMeasurementPhenomena = (companyId: UUID) =>
  getCompany(companyId).pipe(
    concatMap(({ data: company }) => {
      const workspaceId = company.crn?.match(/crn:workspace:([a-f0-9-]+)/)?.[1];
      const companyTree = getPhenomenonsTreeByCompany(initialPageableQuery, companyId).pipe(map(response => response.data.content));
      const workspaceTree = workspaceId
        ? getPhenomenonsTreeByWorkspace(initialPageableQuery, workspaceId).pipe(map(response => response.data.content))
        : of<Phenomenon[]>([]);

      return forkJoin([companyTree, workspaceTree]);
    }),
    map(trees => Array.from(new Map(trees.flat().map(phenomenon => [phenomenon.id, phenomenon] as const)).values()))
  );
